import type { schemaType as provinceSchemaType } from '~/modules/api/rurality/v3/cottage-reviews/province/detail/schema'
import type { schemaType as detailSchemaType } from '~/modules/api/rurality/v3/cottage-reviews/cottage/detail/schema'
import type { schemaType as homeSchemaType } from '~/modules/api/rurality/v3/cottage-reviews/home/schema'
import type { propsInterface } from '~/modules/design-system/sections/s-reviews.vue'

const reviewssUrlBase = ' /opiniones/:cottageSlug/:reviewId'

export const useToSReviews = () => {
  const { t } = useI18n()
  const fromRuralityCottageReviewsProvince = (params: {
    dataIn: provinceSchemaType
    province_slug: string
  }): propsInterface => {
    let items: propsInterface['items'] = []

    items = params.dataIn.reviews.map(item => {
      const linkHref = reviewssUrlBase
        .replace(':cottageSlug', item.cottage.slug)
        .replace(':reviewId', item.id)

      return {
        title: item.title,
        subtitle: item.traveler.name,
        imgUrl: item.traveler.media.url,
        stars: item.points,
        textLeading: item.cottage.name,
        linkCottage: routes().cottageDetail({
          slug: item.cottage.slug,
          province: params.province_slug,
        }),
        text: item.description,
        linkText: t('components.reviews.viewFullReview'),
        linkHref,
      }
    })

    return { items }
  }

  const fromRuralityCottageReviewsDetail = (params: {
    dataIn: detailSchemaType
  }): propsInterface => {
    let items: propsInterface['items'] = []

    items = params.dataIn.reviews.map(item => {
      const linkHref = reviewssUrlBase
        .replace(':cottageSlug', item.cottage.slug)
        .replace(':reviewId', item.id)

      return {
        title: item.title,
        subtitle: item.traveler.name,
        imgUrl: item.traveler.media.url,
        stars: item.points,
        textLeading: item.cottage.name,
        text: item.description,
        linkText: t('components.reviews.viewFullReview'),
        linkHref,
      }
    })

    return { items }
  }

  const fromRuralityCottageReviewsHome = (
    params: homeSchemaType,
  ): propsInterface => {
    let items: propsInterface['items'] = []

    items = params.reviews.map(item => {
      const linkHref = reviewssUrlBase
        .replace(':cottageSlug', item.cottage.slug)
        .replace(':reviewId', item.id)

      return {
        title: item.title,
        subtitle: item.traveler.name,
        imgUrl: item.traveler.media.url,
        stars: item.points,
        textLeading: item.cottage.name,
        linkCottage: routes().cottageDetail({
          slug: item.cottage.slug,
          province: item.cottage.province.slug,
        }),
        text: item.description,
        linkText: t('components.reviews.viewFullReview'),
        linkHref,
      }
    })

    return { items }
  }

  return {
    fromRuralityCottageReviewsProvince,
    fromRuralityCottageReviewsDetail,
    fromRuralityCottageReviewsHome,
  }
}
